import { IRootState } from 'app/shared/reducers';
import { getDate } from 'app/shared/util/date-utils';
import { createSelector } from 'reselect';
import { ContractState } from './state';

const selectContractState = (state: IRootState) => state.contract;

export const getSubscriptionsList = createSelector<IRootState, ContractState, any>(selectContractState, (contract: ContractState) =>
  (contract.subscriptionList || []).map(el => ({
    subscriptionNumber: el.subscriptionNumber,
    subscriber: `${el.subscriber.firstName} ${el.subscriber.lastName}`,
    firstName: el.subscriber.firstName,
    lastName: el.subscriber.lastName,
    duration: `Du ${getDate(el.startDate || '')} Au ${getDate(el.endDate || '')}`,
    selled: `${el?.sellingPoint?.name || ''} - ${el?.seller || ''}`,
    subscriptionStatus: el.status,
    nbDossiers: el.nbClaims,
    title: el.subscriber.title,
    sku: el.sku,
    birthDate: getDate(el.subscriber.birthdate || ''),
    startDate: getDate(el.startDate || ''),
    nbClaims: el.nbClaims,
    nbClaimsInProgress: el.nbClaimsInProgress,
    valid: el.verified,
  }))
);

export const getUserInfoSelector = createSelector<IRootState, ContractState, any>(selectContractState, (contract: ContractState) => ({
  fullName: `${contract?.subscriptionModel?.subscriptionSelected?.subscriber?.firstName || ''} ${
    contract?.subscriptionModel?.subscriptionSelected?.subscriber?.lastName || ''
  }`,
  firstName: contract?.subscriptionModel?.subscriptionSelected?.subscriber?.firstName || '',
  lastName: contract?.subscriptionModel?.subscriptionSelected?.subscriber?.lastName || '',
  dateBirth: getDate(contract?.subscriptionModel?.subscriptionSelected?.subscriber?.birthdate || ''),
  placeBirth: `${contract?.subscriptionModel?.subscriptionSelected?.subscriber?.placeOfBirth || ''}`,
  street: contract?.subscriptionModel?.subscriptionSelected?.subscriber?.address?.address || '',
  streetNumber: contract?.subscriptionModel?.subscriptionSelected?.subscriber?.address?.streetNumber || '',
  additionalAddress: contract?.subscriptionModel?.subscriptionSelected?.subscriber?.address?.additionalAddress || '',
  codePostal: contract?.subscriptionModel?.subscriptionSelected?.subscriber?.address?.zipCode || '',
  city: contract?.subscriptionModel?.subscriptionSelected?.subscriber?.address?.city || '',
  email: contract?.subscriptionModel?.subscriptionSelected?.subscriber?.email || '',
  phone: contract?.subscriptionModel?.subscriptionSelected?.subscriber?.phoneNumber || '',
  mobile: contract?.subscriptionModel?.subscriptionSelected?.subscriber?.mobileNumber || '',
  placeOfBirth: contract?.subscriptionModel?.subscriptionSelected?.subscriber?.cityOfBirth || '',
  iso2countryOfBirth: contract?.subscriptionModel?.subscriptionSelected?.subscriber?.iso2countryOfBirth || '',
}));

export const getContractDetails = createSelector<IRootState, ContractState, any>(selectContractState, (contract: ContractState) => ({
  detailsContrat: {
    DateAdhesion: getDate(contract?.subscriptionModel?.subscriptionSelected?.subscriptionDate) || '',
    EffectiveDate: getDate(contract?.subscriptionModel?.subscriptionSelected?.coversEffectiveDate) || '',
    DateCompletedAt: getDate(contract?.subscriptionModel?.subscriptionSelected?.signTxnCompletedAt) || '',
    purchaseStore: ` ${contract?.subscriptionModel?.subscriptionSelected?.insuredGoods[0]?.purchaseStore?.label || ''}`,
    offer: contract?.subscriptionModel?.subscriptionSelected?.offerCodes || '',
    number: contract?.subscriptionModel?.subscriptionSelected?.number || '',
    prelevement: contract?.subscriptionModel?.subscriptionSelected?.debitTransfertAtDayOfMonth || '',
    coversEndDate: getDate(contract?.subscriptionModel?.subscriptionSelected?.coversEndDate) || '',
  },

  insuredProduct: { insureGods: contract?.subscriptionModel?.subscriptionSelected?.insuredGoods },
  contractualDocument: {},
  contact: { subscription: contract?.subscriptionModel?.subscriptionSelected },
  productCode: contract?.subscriptionModel?.subscriptionSelected?.productCode || null,
}));

export const getBankingInfo = createSelector<IRootState, ContractState, any>(selectContractState, (contract: ContractState) => ({
  iban: contract?.subscriptionModel?.subscriptionSelected?.subscriber?.bankingInfo?.iban || '',
  bic: contract?.subscriptionModel?.subscriptionSelected?.subscriber?.bankingInfo?.bic || '',
  firstName: contract?.subscriptionModel?.subscriptionSelected?.subscriber?.firstName || '',
  lastName: contract?.subscriptionModel?.subscriptionSelected?.subscriber?.lastName || '',
  titulaire: contract?.subscriptionModel?.subscriptionSelected?.subscriber?.bankingInfo?.bankAccountHolder || '',
}));

export const getContractState = createSelector<IRootState, ContractState, any>(selectContractState, (contract: ContractState) => ({
  rootSubscription: contract?.subscriptionModel?.subscriptionSelected,
  redirect: contract?.redirect,
  loading: contract?.loading,
  subsByNumberLoading: contract?.subsByNumberLoading,
  productOffreLoading: contract?.productOffreLoading,
  contractuelDocumentsLoading: contract?.contractuelDocumentsLoading,
  listImpyeLoading: contract?.listImpyeLoading,
  listImpaye: contract?.listImpaye,
  productOffre: contract?.subscriptionModel?.productOffer,
}));
